/**
 * A form multi-line text input.
 * similar to ./TextField
 */

import React from 'react';

import * as S from './TextArea.styles';

type TextAreaAdditionalProps = {
  handleChange: (value: string) => void;
};

export const TextArea = (
  props: Record<string, any> & TextAreaAdditionalProps
) => {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    props.handleChange(e.target.value);
  };
  return <S.TextArea {...props} onChange={handleChange} />;
};
